import { Container, Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useEffect, useState } from "react";
// import About from "./Aboutpage";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import WelfareBanner from "./Bannersection";
import KwdcHeader from "./LoginHeader";
import PublicSiteFooter from "./PublicSiteFooter";
import { config } from "../CommonUtils/CommonURLS";
import axios from "axios";
import { FaDownload, FaRegFilePdf } from "react-icons/fa";
// import { Facebook, Twitter, Youtube, Instagram } from 'react-bootstrap-icons';

// const keyPeople = [
//   {
//     image: "../images/key-people1.webp",
//     name: "Sri Konidala Pawan Kalyan",
//     designation: (
//       <>
//         Deputy Chief Minister, Panchayat Raj & <br /> Rural Development & Rural Water Supply, <br /> Environment Forest Science & <br />
//         Technology
//       </>
//     ),
//   },
//   {
//     image: "../images/key-people2.webp",
//     name: "Smt.S.Savita",
//     designation: "Hon'ble Minister for BC Welfare",
//   },
//   {
//     image: "../images/key-people3.webp",
//     name: "Sri Kothapalli Subbarayudu",
//     designation: " Kapu Welfare & Development Chairman",
//   },
// ];

const buildLatestNewsFileUrl = (filePath) => {
  if (!filePath) {
    return "";
  }

  if (/^https?:\/\//i.test(filePath)) {
    return filePath;
  }

  return `${config.url.FILE_DOWNLOAD_URL}${filePath}`;
};

const formatEventDateParts = (dateValue) => {
  if (!dateValue) {
    return { day: "--", month: "---", year: "----" };
  }

  const [day = "--", month = "--", year = "----"] = dateValue.split("/");
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const monthIndex = Number(month) - 1;

  return {
    day,
    month: monthNames[monthIndex] || month,
    year,
  };
};

export default function Home() {
  const navigate = useNavigate();
  const [newsItems, setNewsItems] = useState([]);
  const [eventsItems, setEventsItems] = useState([]);
  const [keyPeopleDta, setKeyPeopleDta] = useState([]);

  // const newsItems1 = [
  //     "Placement Guaranteed Through Training Partners details under Skill Development Scheme",
  //     "Corporates / Captive Placement Training Partner Details under Skill Development Scheme",
  //     "It is to inform that the registrations under Videshi Vidya Deevena scheme have been stopped with immediate effect. Fresh registrations will be opened after issuing new Common guidelines for Videshi Vidya Deevena upon completion of the selection process of those already registered.",
  //     "Applications are invited for free coaching for DSC Exams",
  // ]

  async function fetchNewsItems() {
    try {
      const response = await axios.get(config.url.STU_URL + "ov-public/getLatestNews");
      if (response?.data?.scode === "01") {
        setNewsItems(response?.data?.data || []);
      } else {
        setNewsItems([]);
      }
    } catch (error) {
      console.error("Error fetching news items:", error);
    }
  }

  async function fetchEventsItems() {
    try {
      const response = await axios.get(config.url.STU_URL + "ov-public/getNewsandEvents");
      if (response?.data?.scode === "01") {
        setEventsItems(response?.data?.data || []);
      } else {
        setEventsItems([]);
      }
    }
    catch (error) {
      console.error("Error fetching news items:", error);
    }
  }


  async function fetchKeyPeopleData() {
    try {
      const response = await axios.get(config.url.STU_URL + "ov-public/getKeyPeopleData");
      if (response?.data?.scode === "01") {
        setKeyPeopleDta(response?.data?.data || []);
      } else {
        setKeyPeopleDta([]);
      }
    } catch (error) {
      console.error("Error fetching key people data:", error);
    }
  }

  useEffect(() => {
    fetchNewsItems(); fetchEventsItems();
    fetchKeyPeopleData();
  }, []);

  const hasMultipleNewsItems = newsItems.length > 1;
  const marqueeNewsItems = hasMultipleNewsItems ? [...newsItems, ...newsItems] : newsItems;

  const downloadLatestNewsPdf = (filePath) => {
    const fileUrl = buildLatestNewsFileUrl(filePath);

    if (!fileUrl) {
      return;
    }

    const fileName = filePath?.split("/").pop() || "latest-news.pdf";
    const downloadLink = document.createElement("a");

    downloadLink.href = fileUrl;
    downloadLink.download = fileName;
    downloadLink.target = "_blank";
    downloadLink.rel = "noopener noreferrer";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const openEventPdf = (filePath) => {
    const fileUrl = buildLatestNewsFileUrl(filePath);
    if (!fileUrl) {
      return;
    }
    window.open(fileUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <KwdcHeader />
      {/* ================banner section================== */}
      <div className="banner-section">
        <WelfareBanner />
      </div>
      {/* =======================about section===================== */}
      <section>
        <div className="container-fluid key-section-bg">
          <div className="container">
            {/* Key People Section */}
            <Row className="align-items-center">
              <Col xxl={4} xl={4} lg={4} md={12} sm={12} xs={12}>
                <div className="kwdc-about">
                  <h3 className="kwdc-h3">
                    <span className="orange-text"> About</span> <br />
                    <span className="middle-text">Kapu Welfare </span> <br />
                    Department
                  </h3>
                  <p>
                    The Government was established the A.P.State Kapu Welfare and Development Corporation for the year 2015 with an aim to promoting the Welfare and Development of the Kapu (Kapu,
                    Telaga, Balija and Ontari sub castes) communities and to serve the marginalized and poor Kapu community members in Andhra Pradesh. It aims at their social, educational and economic
                    development and to bring them on par with other developed communities in the society.{" "}
                  </p>

                  <button class="about-pill-button" onClick={() => navigate("/about")}>
                    <span class="bg-fill"></span>

                    <span class="icon-circle">
                      <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                    </span>

                    <span class="button-text">Read more</span>
                    <span class="arrow-target-zone">
                      <svg class="arrow hover-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                    </span>
                  </button>
                </div>
              </Col>
              <Col xxl={8} xl={8} lg={8} md={12} sm={12} xs={12}>
                {/* <div className="row key-people-section">
                                    {keyPeople.map((person, index) => (
                                        <div
                                            key={index}
                                            className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12"
                                        >
                                            <div className="key-people-div1">
                                                <img
                                                    src={person.image}
                                                    alt={person.name}
                                                    className="img-fluid people-img1"
                                                />
                                                <div className="key-designation">
                                                    <h4 className="key-h4">{person.name}</h4>
                                                    <p className="key-p1">{person.designation}</p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div> */}
                <div className="row key-people-section">
                  {keyPeopleDta?.length > 0 ? (
                    keyPeopleDta.map((person, index) => (
                      <div key={person.sno || index} className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <div className="key-people-div1">
                          <img
                            src={buildLatestNewsFileUrl(person.upload_file)}
                            alt={person.name}
                            className="img-fluid people-img1"
                            onError={(e) => {
                              e.target.src = "/images/fallback-image.jpg";
                            }}
                          />
                          <div className="key-designation">
                            <h4 className="key-h4">{person.name}</h4>
                            <p className="key-p1">
                              {/* {person.designation === "honble_chairman"
                ? "Hon'ble Chairman"
                : person.designation === "special_chief_secretary"
                  ? "Special Chief Secretary to Govt. BC Welfare"
                  : person.designation === "managing_director"
                    ? "Managing Director"
                    : person.designation} */}
                              {person?.display_designation}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="col-12 text-center">No key people found</div>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </section>
      <Container fluid className="kwdc-lt-news-bg">
        <Container>
          <Row className="mx-0">
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div className="news-card shadow">
                <div className="news-header-row">
                  <div>
                    <h2 className="news-title">Latest News</h2>
                  </div>
                  <span className="news-count-badge">{newsItems.length} Updates</span>
                </div>
                {newsItems.length > 0 ? (
                  <div className="ticker-container">
                    <div className={`ticker-wrapper ${hasMultipleNewsItems ? "ticker-wrapper-animated" : ""}`}>
                      {marqueeNewsItems.map((item, index) => {
                        const description = item?.latest_news_description || "Latest update";
                        const newsDate = item?.latest_news_date || "Recent";
                        const filePath = item?.latest_news_file || "";
                        const hasPdf = Boolean(buildLatestNewsFileUrl(filePath));

                        return (
                          <article className="ticker-item" key={`${item?.sno || description}-${index}`}>
                            <div className="ticker-item-inner">
                              {/* <div className="ticker-item-meta">
                                                                <span className="ticker-item-chip">
                                                                    <FaRegFilePdf />
                                                                    {hasPdf ? " PDF Available" : " Update"}
                                                                </span>
                                                                <span className="ticker-item-date">{newsDate}</span>
                                                            </div> */}

                              <div className="ticker-content-row">
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id={`latest-news-tooltip-${index}`} className="latest-news-tooltip">
                                      {description}
                                    </Tooltip>
                                  }
                                >
                                  <p className="newhid-text news-tooltip-trigger">{description}</p>
                                </OverlayTrigger>

                                <div className="ticker-actions">
                                  {hasPdf && (
                                    <button
                                      type="button"
                                      className="news-action-btn news-action-btn-primary"
                                      onClick={() => downloadLatestNewsPdf(filePath)}
                                      aria-label="Download PDF"
                                      title="Download PDF"
                                    >
                                      <FaDownload />
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </article>
                        );
                      })}
                    </div>
                  </div>
                ) : (
                  <div className="news-empty-state">
                    <p>No latest news is available right now.</p>
                    <span>Please check back shortly for new updates.</span>
                  </div>
                )}
              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div className="kwdc-news-events">
                <h2 className="kwdc-news-title2">News & Events</h2>
                <div className="kwdc-news-marquee">
                  <div className="kwdc-news-cards-container">
                    {eventsItems.length > 0 ? eventsItems.map((item, index) => {
                      const eventDate = formatEventDateParts(item?.news_date);
                      const eventFilePath = item?.artical_file1 || "";
                      const hasEventFile = Boolean(buildLatestNewsFileUrl(eventFilePath));

                      return (
                        <Row className="kwdc-news-card1 align-items-center" key={item?.artical_id || item?.sno || index}>
                          <Col xxl={2} xl={3} lg={3} md={3} sm={3} xs={4}>
                            <div className="kwdc-news-date">
                              <p className="kwdc-yellow-text">{eventDate.day}</p>
                              <p>{eventDate.month}</p>
                              <hr />
                              <p>{eventDate.year}</p>
                            </div>
                          </Col>
                          <Col xxl={8} xl={7} lg={7} md={7} sm={7} xs={6}>
                            <p className="kwdc-news-middle-text">{item?.artical_description || "-"}</p>
                          </Col>
                          <Col xxl={2} xl={2} lg={2} md={2} sm={2} xs={2}>
                            {hasEventFile ? (
                              <button
                                type="button"
                                className="btn btn-link p-0 border-0 bg-transparent w-100"
                                onClick={() => openEventPdf(eventFilePath)}
                                aria-label="Open event PDF"
                                title="Open event PDF"
                              >
                                <img src="../images/kwdc-news-arrow.svg" className="kwdc-news-arrow img-fluid" />
                              </button>
                            ) : (
                              <img src="../images/kwdc-news-arrow.svg" className="kwdc-news-arrow img-fluid" />
                            )}
                          </Col>
                        </Row>
                      );
                    }) : (
                      <Row className="kwdc-news-card1 align-items-center">
                        <Col xs={12}>
                          <p className="kwdc-news-middle-text text-center">No news and events are available right now.</p>
                        </Col>
                      </Row>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Row>
        </Container>
      </Container>


      {/* ========================schems section======================= */}

      <Container className="py-5">
        <div className="kwdc-sec-heading">
          <h1>Kapu Welfare</h1>
          <h2>Schemes</h2>
        </div>
        <div className="kwdc-cards">
          <Row className=" ">
            <Col xxl={3} xl={3} lg={4} md={6} sm={6} xs={12}>
              <div className="kwdc-service-card">
                <div className="kwdc-service-circle">
                  <img src="/images/kapu scheme icon1.svg" alt="icons" className="img-fluid icon1" />{" "}
                </div>

                <div className="kwdc-service-content">
                  <h3 className="kwdc-service-title">Skill Development Scheme</h3>
                  <p className="kwdc-service-description">Provides free skill training for unemployed youth from the Kapu community to improve their job opportunities and career growth.</p>
                  <button class="kwdc-btn">
                    <span class="know-bg-fill"></span>
                    <span class="arrow-circle">
                      <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                    </span>

                    <span class="know-btn-text">Know more</span>
                    <span class="know-arrow-target-zone">
                      <svg class="arrow know-hover-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                    </span>
                  </button>
                </div>
              </div>
            </Col>
            <Col xxl={3} xl={3} lg={4} md={6} sm={6} xs={12}>
              <div className="kwdc-service-card">
                <div className="kwdc-service-circle">
                  <img src="/images/kapu scheme icon2.svg" alt="icons" className="img-fluid icon1" />{" "}
                </div>

                <div className="kwdc-service-content">
                  <h3 className="kwdc-service-title">Tailoring Scheme</h3>
                  <p className="kwdc-service-description">Provides tailoring training and support to women and unemployed persons to help them start self-employment and earn a livelihood</p>
                  <button class="kwdc-btn">
                    <span class="know-bg-fill"></span>
                    <span class="arrow-circle">
                      <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                    </span>

                    <span class="know-btn-text">Know more</span>
                    <span class="know-arrow-target-zone">
                      <svg class="arrow know-hover-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                    </span>
                  </button>
                </div>
              </div>
            </Col>
            <Col xxl={3} xl={3} lg={4} md={6} sm={6} xs={12}>
              <div className="kwdc-service-card">
                <div className="kwdc-service-circle">
                  <img src="/images/kapu scheme icon3.svg" alt="icons" className="img-fluid icon1" />{" "}
                </div>

                <div className="kwdc-service-content">
                  <h3 className="kwdc-service-title">Vidyonnati Scheme</h3>
                  <p className="kwdc-service-description">
                    Provides financial assistance and coaching support to help them prepare for competitive examinations and achieve higher education and career goals.
                  </p>
                  <button class="kwdc-btn">
                    <span class="know-bg-fill"></span>
                    <span class="arrow-circle">
                      <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                    </span>

                    <span class="know-btn-text">Know more</span>
                    <span class="know-arrow-target-zone">
                      <svg class="arrow know-hover-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                    </span>
                  </button>
                </div>
              </div>
            </Col>

            <Col xxl={3} xl={3} lg={4} md={6} sm={6} xs={12}>
              <div className="kwdc-service-card">
                <div className="kwdc-service-circle">
                  <img src="/images/kapu scheme icon4.svg" alt="icons" className="img-fluid icon1" />{" "}
                </div>

                <div className="kwdc-service-content">
                  <h3 className="kwdc-service-title">Driver Training Scheme</h3>
                  <p className="kwdc-service-description">Provides professional driving training to unemployed youth from the Kapu community to help them gain employment as skilled drivers.</p>
                  <button class="kwdc-btn">
                    <span class="know-bg-fill"></span>
                    <span class="arrow-circle">
                      <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                    </span>

                    <span class="know-btn-text">Know more</span>
                    <span class="know-arrow-target-zone">
                      <svg class="arrow know-hover-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                    </span>
                  </button>
                </div>
              </div>
            </Col>

            <Col xxl={3} xl={3} lg={4} md={6} sm={6} xs={12}>
              <div className="kwdc-service-card">
                <div className="kwdc-service-circle">
                  <img src="/images/kapu scheme icon5.svg" alt="icons" className="img-fluid icon1" />{" "}
                </div>

                <div className="kwdc-service-content">
                  <h3 className="kwdc-service-title">Grievance Monitoring System</h3>
                  <p className="kwdc-service-description">Helps Kapu community members report their problems and ensures those issues are resolved quickly</p>
                  <button class="kwdc-btn">
                    <span class="know-bg-fill"></span>
                    <span class="arrow-circle">
                      <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                    </span>

                    <span class="know-btn-text">Know more</span>
                    <span class="know-arrow-target-zone">
                      <svg class="arrow know-hover-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                    </span>
                  </button>
                </div>
              </div>
            </Col>
            <Col xxl={3} xl={3} lg={4} md={6} sm={6} xs={12}>
              <div className="kwdc-service-card">
                <div className="kwdc-service-circle">
                  <img src="/images/kapu scheme icon6.svg" alt="icons" className="img-fluid icon1" />{" "}
                </div>

                <div className="kwdc-service-content">
                  <h3 className="kwdc-service-title">Videshi Vidya Deevena</h3>
                  <p className="kwdc-service-description">Provides financial assistance to students from the Kapu community to support higher education in foreign universities.</p>
                  <button class="kwdc-btn">
                    <span class="know-bg-fill"></span>
                    <span class="arrow-circle">
                      <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                    </span>

                    <span class="know-btn-text">Know more</span>
                    <span class="know-arrow-target-zone">
                      <svg class="arrow know-hover-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                    </span>
                  </button>
                </div>
              </div>
            </Col>
            <Col xxl={3} xl={3} lg={4} md={6} sm={6} xs={12}>
              <div className="kwdc-service-card">
                <div className="kwdc-service-circle">
                  <img src="/images/kapu scheme icon7.svg" alt="icons" className="img-fluid icon1" />{" "}
                </div>

                <div className="kwdc-service-content">
                  <h3 className="kwdc-service-title">Issue Tracker System</h3>
                  <p className="kwdc-service-description">Helps record and monitor problems reported by Kapu community members and tracks their progress until they are resolved.</p>
                  <button class="kwdc-btn">
                    <span class="know-bg-fill"></span>
                    <span class="arrow-circle">
                      <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                    </span>

                    <span class="know-btn-text">Know more</span>
                    <span class="know-arrow-target-zone">
                      <svg class="arrow know-hover-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                    </span>
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>

      {/* ======================gallery section==================================== */}
      <div className="kwdc-gallery-section" id="gallery">
        <Container>
          <div className="gallery-head">
            <h2 className="kwdc-gallery-heading">Gallery</h2>
            <button className="btn btn-sm gallery-pill-button" onClick={() => navigate("/GalleryPage")}>
              View all
            </button>
          </div>
          <Row>
            <Col xxl={4} xl={4} lg={4} md={6} sm={6} xs={12}>
              <img src="../images/g1.webp" className="img-fluid gallery-img" about="gallery-img" />
            </Col>
            <Col xxl={4} xl={4} lg={4} md={6} sm={6} xs={12}>
              <img src="../images/g2.webp" className="img-fluid gallery-img" about="gallery-img" />
            </Col>
            <Col xxl={4} xl={4} lg={4} md={6} sm={6} xs={12}>
              <img src="../images/g3.webp" className="img-fluid gallery-img" about="gallery-img" />
            </Col>
            <Col xxl={4} xl={4} lg={4} md={6} sm={6} xs={12}>
              <img src="../images/g4.webp" className="img-fluid gallery-img" about="gallery-img" />
            </Col>
            <Col xxl={4} xl={4} lg={4} md={6} sm={6} xs={12}>
              <img src="../images/g5.webp" className="img-fluid gallery-img" about="gallery-img" />
            </Col>
            <Col xxl={4} xl={4} lg={4} md={6} sm={6} xs={12}>
              <img src="../images/g6.webp" className="img-fluid gallery-img" about="gallery-img" />
            </Col>
          </Row>
        </Container>
      </div>

      <PublicSiteFooter />
    </>
  );
}
